import React, { useEffect, useState } from "react";
import GenericCard from "components/UI/GenericCard/GenericCard";
import ActiveLight from "components/UI/ActiveLight/ActiveLight";
import {
  apiGetAutomationStatus,
  apiStartAutomation,
  apiStopAutomation,
} from "api/apiTws";
import { Button } from "antd";
import AutomationLogsModal from "./AutomationLogsModal";

const AutomationRunningStatus = () => {
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const getAutomationStatus = async () => {
    try {
      const isActive = await apiGetAutomationStatus();
      setStatus(isActive);
    } catch (err) {}
  };

  const onStartAutomation = async () => {
    try {
      setIsLoading(true);
      const isActive = await apiStartAutomation();
      setStatus(isActive);
    } catch (err) {}
    setIsLoading(false);
  };

  const onStopAutomation = async () => {
    try {
      setIsLoading(true);
      const isActive = await apiStopAutomation();
      setStatus(isActive);
    } catch (err) {}
    setIsLoading(false);
  };

  useEffect(() => {
    getAutomationStatus();
  }, []);

  return (
    status !== null && (
      <GenericCard title="Automation Status">
        {!!status ? (
          <div>
            <ActiveLight />

            <Button
              className="mt-4"
              onClick={onStopAutomation}
              loading={isLoading}
            >
              Stop automation
            </Button>
          </div>
        ) : (
          <div>
            <h3 className="red">Off</h3>
            <Button
              className="mt-4"
              onClick={onStartAutomation}
              loading={isLoading}
            >
              Start automation
            </Button>
          </div>
        )}
        <div className="pt-4">
          <AutomationLogsModal />
        </div>
      </GenericCard>
    )
  );
};

export default AutomationRunningStatus;
